var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurVisionUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OurVisionUnderline_2",
    "data-name": "OurVisionUnderline 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 632.18 7.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .OurVisionUnderline-1 {\n        fill: #f0e2cb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OurVisionUnderline_1",
    "data-name": "OurVisionUnderline 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M631.44,1.45c.93.04.6-.38.74-.46-1.56.09-.7.57-.74.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "616.04 2.4 616.31 2.22 614.04 2.64 616.04 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M601.63,2.38c1.36.71,5.22-.11,7.79.14l.42.16,1.16-.57c-3.12.09-7.17.47-9.37.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M593.95.84c.47.28-1.66.24,1.79.09-.17-.03-.22-.05-.32-.07-.31,0-.74,0-1.47-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M595.41.85c1.52-.02-.99-.23,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M588.41,1.01l2-.25c-.42-.16-2.2-.2-1.54-.32-2.05.13-1.63.3-.46.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M586.51,1.53l1.04-.1c-.18-.07-.46-.09-1.04.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M589.74,1.2l-2.2.22c.29.12.32.35,1.01-.08-.18.21.25,0,1.19-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M590.99,1.31c1.12.16,2.57.25.56.5,3.82-.1,3.26-.6-.56-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M600.89,3.12l1.5.21,1.3-.24c-.65.12-2.89-.19-2.79.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M575.96.63c-.12.15.67.41.82.6l1.48-.17c-.76-.1-2.2-.2-2.3-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M576.78,1.23l-2.21.26c1.97.03,2.33-.09,2.21-.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "586.15 2.32 589.78 1.78 585.46 2.33 586.15 2.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "567.52 .61 568.77 .26 566.54 .79 567.52 .61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M561.92.67c.93-.29-1.27-.49-.29-.67-1.52.05-2.82.3-3.99.53,1.24-.12,2.57-.09,4.28.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M555.68.85c.62-.07,1.26-.19,1.96-.33-.66.07-1.31.16-1.96.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M570.81,1.42c-.17-.09-.5-.33-1.74-.43l.87.43c.27,0,.57,0,.87,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M569.97,1.42h-.03c-.94-.02-1.6-.03-1.88-.04.24,0,.81.01,1.91.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M571.02,1.42c-.08,0-.14,0-.22,0,.08.04.13.06.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M580.36,1.93c-1.3.24-4,.49-1.39.86.93-.29-.57-.5,1.39-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M572.1,1.95l2.35.1c-.05-.11-.47-.28.17-.4l-2.52.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "570.95 2.09 572.1 1.95 571.23 1.92 570.95 2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M559.7,1.25c-1.01.19-2.12.2-3.37.23,1.34.08,2.73.13,4.05.13.19-.13.77-.37-.67-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M564.69,1.37c-.07,0-.16.01-.23.02.14.04.25.05.23-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M544,1.48c.07.02.13.05.2.08.02-.03.03-.05.05-.07h-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M560.6,1.69c1.01.08,1.61-.02,2.19-.15-.75.04-1.55.07-2.41.07-.08.06-.1.1.23.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M552.25,1.05c.53.09,1.12.17,1.75.24-.51-.14-1.56-.35-1.75-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M564.13,1.28c.05,0,.1-.01.15-.02-.33-.09-.29-.05-.15.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M564.13,1.28c-.52.06-.93.17-1.34.26.61-.03,1.18-.08,1.68-.14-.12-.03-.25-.08-.34-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M540.27,4.22c.18-.4,2.83-.76,5.12-.34,2.25-.3.78-1.6-1.19-2.33-.07.17-.07.33-2.39.57.81.22,5.14.51,3.19.87-3.07.2-2.52-.14-4.01-.35,1.27.49-3.91.72-3.24,1.44l2.69-.25c.05.11-.93.29-.18.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M548.62,1.6l.95-.05c-1.09-.07-1.87-.23-3.3-.54-1.59.19-1.92.34-2.03.47l4.7.06-.33.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M553.85,1.55c-.75.43-3.04.61-1.63,1.08,2.8-.03,1.96-.36,3.63-.55-4.52.11,1.3-.24-1.97-.49.89-.07,1.69-.1,2.44-.11-.81-.05-1.6-.12-2.34-.2.04,0,.07.02.1.03h.02s0,0,0,0c.19.05.26.09.04.06-.02,0-.07,0-.09,0-.03.06-.11.11-.2.16-1.31-.09-.21-.11.2-.16.01-.02.05-.04.05-.06,0,0-.01,0-.02,0l-4.53.23c.96.06,2.16.05,4.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M576.56,3.72c-.14-.04-.13-.07-.15-.1-.29.05-.4.09.15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M574.7,3.46c.33-.06.6-.23,1.67-.19.93.13,0,.21.04.35.64-.11,2.26-.31.23-.52l-.32.06c-1.82-.15-4.16-.69-3.84-.75.53.39,1,.66,2.21,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M564.15,2.61l-3.77.21,1.92.37-.1-.22c2.14.09,1.68-.19,1.95-.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "543.57 1.26 544.07 .81 541.89 1.45 543.57 1.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "538.67 1.31 538.85 .92 537.56 1.16 538.67 1.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M262.3,6.12l-1.11.11c.52-.03.86-.07,1.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M270.32,6.15l.2-.19c-.37.11-.52.19-.2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M418.39,1.31c-1.61-.37-3.41-.94-3.22-.5l.5.43c1.13-.08,1.99-.03,2.72.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M336.01,3.87c.15.04.31.09.47.13.39-.15.76-.29,1.09-.41-.47.09-1,.18-1.56.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M334.87,5.67l-2.13-.28c.48.1,1.16.19,2.13.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M218.51,6.56l-1.29.44c2.02,0,1.13-.22,1.29-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M488.51,1.46c-1.39-.17-2.5-.24-3.47-.26,1.68.25,3.03.62,3.47.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M265.46,1.52c-.68.08-.97.17-.95.26.7-.07,1.09-.16.95-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M481.02,1.19c.25.04.49.07.74.1,1.02-.07,2.04-.13,3.28-.1-1.24-.19-2.66-.3-4.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M59.71,6.14c-.12-.02-.25-.03-.36-.05-.04.06.12.06.36.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M13.45,1.75c.46-.03,1.2-.03,1.9-.03-.34-.03-.91-.03-1.9.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M518.97,1.12c1.04-.03.16-.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M524.02,2.84c-.22.05-.39.11-.42.21.09-.1.23-.17.42-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M470.67,3.89s-.06,0-.09,0c.31.09.26.07.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M520.53,1.32c-.39-.05-.84-.1-1.33-.13.21.03.62.08,1.33.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M520.32,1.11c.36.02.64.03.91.04.13-.07.01-.12-.91-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M517.52,1.14c.59,0,1.15.01,1.68.05-.2-.03-.29-.05-.23-.07-.3,0-.73.02-1.45.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M144.8,5.02c-.07-.01-.15-.02-.22-.04-1.05.18-.59.15.22.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M391.35,5.81s.07-.02.12-.02c-.05,0-.11-.01-.15-.02l.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M387.62,6.13c1.59-.54,2.49-.47,3.7-.36l-1.23-1.25-2.46,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M243.1,6.24l2.62.39c-3.16.64-5.45.42-2.99.97.37-1.36,10.18-.14,10.55-1.49l1.73.29c-.49-.01-.57.07-1.06.05,3.36.65,2.5-.98,6.82-.79,1.51.1,2.56.3,1.53.46l3.36-.33c.98.03.74.26-.23.24l5.13-.11-.04.04c.73-.21,2.39-.54,3.2-.68,1.3.2-.65.14-.32.31l2.84-.33c1.16.35-1.2.69-3.16.64,2.65,1.36,2.35-.34,8.07.45l-2.68.17c1.73.77,3.82.49,6.85.97-.72-.25-6.07-1.21-2.98-1.55.87.1,2.01.15,3.67-.12.02.48,1.64.36,3.67.34l-.14.64c2.2-.18,2.02-.51,3.31-.8,2.45.06,2.95.56,3.53.98,3.92.1-2.71-.8,1.93-.91,3.26.25,5.55-.01,9.44-.4,2.28.22-.4.39.42.57l2.02-.51c.49.01.33.17.25.25,1.7-.2.14-.64,2.82-.81.72-.7,5.5,1.03,8.81.23.82.18-.39.39-.15.64,4.55-.52,3.9-.38,7.63-1.09l3.18.42c-2.34-.48.65-1.05,3.27-1.51-.83-.23-1.54-.44-2.01-.53l4.17-.34c.5.11.08.32-.6.59.28-.05.55-.1.77-.15,1.49.24.72.61-.35.96-.51-.13-1.01-.26-1.5-.4-1.03.39-2,.82-1.78,1.19.27-.07.79-.14,1.37-.17-.27.11-.44.2-.32.26.14.07.58-.07,1.26-.24l.95.71.23-.28,5.46.45c3.91-.72,7.31-1.77,13.51-2.06-1.54.52-.33.85-.42,1.47-1.69-.66-4.8.28-8.02.14,1.68.07,1.31.36.88.47l5.73-.59c-.13.51,1.22.38,2.71.59-1.13-1,4.27-.67,6.61-.97.14.34-.41.68-3.26.6,3.14.76,4.06-1.17,7.14-.53-.7,0-1.07-.04-1.34.13,1.62-.3,5.59-.06,4.66.23h-.69c4.61.13,14.04.02,14.73-.83.05.11-.6,1.03-.88,1.2l8.23-2.86c-.73.73,2.06,2.47-1.77,2.88,1.1.1,2.46.23,4.77-.03-.75-.1-1.87-1.06-.84-1.12,2.81.81,1.95.44,5.42,1.13-1.12-.16.12-1.3,1.9-1.26-.28.17.15,1.13-.5,1.25l4.42-1.12c-1.1.2-.2.95.79,1.27-.46-.22,3.82.02,5-.09l-1.87-.26c4.99.17,4.93-1.58,9.88-1.52-.6.23-1.48,1.43,1.04,1.57,1.15-.58,5.11-2.77,9.49-3.21l.84.33,3.36-.37c-2.09.87-7.96,2.69-11.17,3.4,1.87.26.52.39,3.31.36.99.31-1.52.47-2.35.49l6.51.2c-.29-.67,4.98-.67,4.73-1.23l-7.07.69c-.29-.67,4.09-1.91,8.7-1.79,1.17.27-.88,1.2-.78,1.42.6-.23,4.38-.44,4.8-.28l-1.96.36c2.57.25,4.19-.89,7.27-.25,1.06.04,3.18.87,3.36.47-1.74-.77-2.07-3.14-.92-3.72.37.05,5.59.74,6.81,1.11,1.75.6-2.63,1.43-1.14,1.95.06-.18,1.03-.41,1.44-.48,1.12.16-.46.57,1.97.49.41-.68,4.94.06,1.15-.58,2.38-.19,2.53.14,5.32.11-.89-.44,2.51-1.5,4.89-1.69-.14.17.39.4.65.5,4.87.06,7.49.37,12.03.38.42.17,2.61.37,1.68.66.65-.12,1.25-.35,2.65-.37,2.71.59-3.12.09-1.06.8.18-.4,3.62-.55,5.62-.79-.61-.61-4.61-.12-6.61.13,0-.84,3.47-1.73,8.22-2.11,3.77-.21,1.64.55,2.29.43,7.09.15,6.04-1.47,11.92-.86,2.33.54.1,1.07.62,1.46-3.07.2-4.72-.34-6.8-.32l2.56.26c-.98.18-3.03.31-4.15.16,1.96.48,11.97.1,17.44.55.97-.18,2.65-.37,1.86-.58l-1.73.07c-1.59-.43,3.26-.6,1.07-.8,2.32-.3,4.92-.78,8.19-.54l.61.61c-.07-.18-2.14-.37-3.05-.18,1.36-.27,5.01.83,6.5.03l-2.29-.43c2.33-.31,5.21-.96,8.11-.76-1.32-.61-.67.07-2.73-.64,1.78.88-7.41-.04-4.54.89-2.11-.82-3.65-.35-6.41-1.05.09.2.98.39-1.45.29-.11.06-.37.13-.53.18-.07,0-.1,0-.16-.02.05,0,.08.02.13.02-.11.03-.12.04.05,0,.58.09,1.05.2,1.24.31-1.21.46-5.07.45-6.38.69-1.44-.1.6-.23-.18-.45l-1.95.36c-.19-.45-3.83-.75-.43-1.01l-3.06-.02c-1.8-.25-4.28-.35-5.81-.17-1.44-.1-3.64.5-2.39.14l-4.8.28-.04-.11c-4.73-.06-9.74.74-15.15-.07-1.59.11-3.24.25-5.91.12l-.52-.39c-2.05.13-6.14-.39-7.02.01-2.21-1.05-9.93-.23-13.53-.42l-.14.51c-2.48-.03-4.85.11-7.93.32l.19.45c-2.65.37-6.81-.32-11.01-.28.29-.17,1.35-.13,2.1-.02-5.01-1.01-10.57.73-15.11,0-1.13.16-1.95.11-2.75,0,.11,0,.2,0,.28-.02-.12,0-.29,0-.46,0-.5-.08-1.01-.17-1.57-.24.47.11.93.2,1.32.24-.87,0-2.2.06-3.49.18l-.55-.48c-.11,0-.19,0-.3.01-1.27-.18-1.02.23-.34.59-.65.08-1.25.17-1.72.29-1.03-.78-3.41.26-4.82-.57-.88.4-6.52.3-7.22,1.15-.04-.11-.43-.16.27-.17-1.45-.1-2.89-.19-4.19.04l-.61-.61-3.16.82c-1.92-.37-2.71-.59-.81-1.06-4.6.72-3.73.27-7.65.99l.19-.4c-1.4.01-3.64.54-4.48.22-3.13-.75-15.48-.11-23.52-.81,1.56,1.17-3.73-.52-4.05.38-.47-.28-1.59-.43-.29-.67-4.1.27-6.16-.44-8.99.32-.47-.28.88-.4.46-.57-.33.06-1.3.24-1.73.07-.42-.16.6-.23,1.25-.35-4.19.04-4.61.89-4.92,1.69-2.12-.38-3.18-.33-4.71.2-.74-.26-1.97-.53.63-.63-1.46-.04-8.94-.39-9.09.25-.46-.16-2.05-.05-2.43.03-3.28-.04-3.57-.1-6.8-.04l.89.1c-1.27.77-2.68.17-5.28.26l.07-.08c-5.96-.56-2.57.27-8.46-.37l.32.48c-.55,1.03-5.21-.61-8.62-.22l1.23.27c-1.86.35-5.21-1.4-7.08-1.53-.41-.09.64-.14,1.21-.21-4.9-.61-.64.63-4.29.77-.67-.34.87-.86-1.59-.93-1.23-.27-7.13,1.1-10.49.45.74.26,1.47.52-.22.72-2.6.09-7.03-.99-9.38-.17-.33-.07-.46-.14-.47-.2-1.99.21-6.46.35-7.66.8-1.84-1.66-12.36.8-12.31-.73l-6.11.08.16-.16c-3.91-.1-5.29.26-6.66.63-.9-.1-.24-.25-.17-.33-5.71-.31-6.28-.25-11.07.51l-.5-.5c-1.3.29-8.26-.78-13.86-.2.05-.06.17-.15.62-.22-6.3.58-15.09-1.38-17.4.42l-4.16.44c5.38.14-.8.78,1.41,1.08-2.12.11-5.47-.55-2.87-.64l.41.09c.96-.94-6.69-.34-6.54-.98-10.59.04-20.91-.48-30.82-.53l1.14.73-3.46-.04c-.91-.17-1.22-.57,1.25-.54-1.3-.42-4.14.35-4.21.5-4.83-.3,1.89-.85.41-.87l-2.01.05.45.09c-1.63.3-1.78.61-4.74.58-1.88-.15-.96-.45-1.7-.48,0-.05-.25-.08-1.13-.02l-4.36-.06,1.74.58c-1.93.28-4.1-.03-2.09.62-2.95-1.01-16.26-.37-18.07-.68-2.71.42-5.38.41-8.68.36.82.12,1.31.77-1.54.69,1.04-1.34-5.22-.58-7.53-1.55,2.06.64-8.11.15-4.88,1.06-2.38-.11-.14-.5-1.95-.82-5.67.52-12.49-.34-19.49-.17-.11.18,1.06.45-.44.71l-3.7-.88c-1.38.09-1.27,1.01-3.8.4.36.15.89.37-.04.43-13.72-.86-28.04.69-41.97-.92,1.89.34.63.37-.81.39.94.08-.02.43.16.67l-5.83-.66c-1.06.66-6.25.04-6.86.67l1.85-.11c-2.46.75,3.44,1.66,3.08,2.62,2.75-.85,7.25,1.26,11.77.05,1,.2-.85.31-.32.53,1.14-.41,2.53-.5,5.09-.31l-.29.1c7.19-.1,10.28.31,18.36.58l-.6-.47c1.74.06,2.1.21,2.92.33,1.99-.72-4.88-.04-3.06-.83,2.3.96,12.25.02,13.8,1.12,2.67,0-.78-.55,1.89-.54l.71.3.68-.38c1.75.06,2.63.43,2.7.69-.42-.03-1.21.07-1.66.09,2.27.35,6.4-.12,7.18,0l-2.57-.18c7.29-.27,16.19.12,23.24-.48l-.53-.22c5.38-.41,4.31.25,10.21.06l-.21.05c1.18-.22,2.76-.33,4.38-.31-1.49.26,2.81.51.85.8,5.83-.44,2.89-.35,6.74-1.18l.89.37c1.31-.33,1.42-.51,4.37-.61-2.42.32,1.88.57-.83.99,6.19.81,9.19-.82,12.03.37,2.84-1.03-5.36-.57-3.76-.79-1.33-.34,2.35-.77,4.29-.66,1.98.02,3.36,1.31,8.33,1.3-.49,0-.53.07-1.02.07,1.86.26,3.65-.35,5.93.07,1.28-.62,2.96.04,3.33-.75l-4.56.18c2.59-.21,5.01-1.13,9.27-.68-.33.16-1.6.37-2.47.49,1.25.23,2.4-.15,3.69.09-.37.79-5.54.17-8.32.77,1.34.34,5.24-.57,3.85.29,2-1.09,4.9.14,8.27-.69l-.22.47c.53-.07,1.64-.3,2.62-.29l-1.78.61c2.73-.52,5.26.46,7.87.18-5.48.01-1.23-.57-3.54-.92,6.75-.63,3.88,1.24,11.45,1.02-1.02.07-3.84-.29-2.24-.51,1.44.1,3.34.28,4.22.53,5.01-.1-.77-.49,1.36-.78,1.71.58,2.46-.23,4.66-.42l.02.48c5.71.31,1.51-1,6.65-.63l-2.17.67,2.68-.17-.55.55c2.92-.41,3.82-.3,6.68-.15-.66-.34.37-.88,2.9-.89,1.72.29-.97.46,2.62.39-.81.3-1.7.68-3.26.24-.16.16-.8.3-.96.46,1.86.33,4.67.08,5.97.07-.5-.02-1.1-.04-1.4-.11l5.2-.67c.82.18.17.33-.47.47,1.05-.05,1.78-.27,3.33-.31-.4.39-.3.8-2.5.98l4.95-.43c.33.17,2.54.47,1.9.61,2.74.23,6.73-.76,10.37-.45.19-.08.57-.15,1.34-.2,3.42.09,6.45.57,10.5.04l2.3.7c3.17-.16-3.11-.89,2.17-1.15,3.74-.22,1.4.6,2.71.8,1.86-.35,5.1-1.07,8.54-.5-1.14.13-2.03.03-3.09.08ZM282.26,5.94c-.76.1-2.27.41-2.83.13.86-.55,1.53-.29,2.83-.13ZM341.78,4.8c-.56.16-1.44.08-2.42-.1.71-.04,1.52-.02,2.42.1ZM507.58,1.51s-.06.01-.08.02c-1.69-.19-1.09-.11.08-.02ZM511.1,1.72c.35-.07.33-.13.18-.2-.25.12-1.03.13-1.93.1.25.13.7.21,1.75.11ZM133.71,1.76l.68.13c-1.54.14-1.11.01-.68-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M335.03,5.46c-.21-.08-.27-.17-.32-.26-.3.08-.3.17.32.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M218.75,6.48s-.08,0-.12,0c-.07.03-.1.06-.12.09l.24-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M456.66,5.79c-.72-.07-1.13-.16-1.4-.25-.04.12.29.22,1.4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M529.72.9l-2.25.12c1.09-.02,1.48.08,2.03.16-.05-.11-.48-.28.22-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M549.26,3.9c.33-.06.7,0,1.02-.07l-.09-.22c-1.4.01-2.38.19-.93.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M531.8,2.51c.18.41,1.59.27,3.17.19-.09,0-.18,0-.28,0,.46-.57-1.22-.38-2.89-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M535.33,2.69c.49-.02.98-.03,1.46,0,.18-.23-.59-.05-1.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M515.55,1.45c.75.1.47-.52.89-.35.83-.52-4.99.62-.89.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "533.08 3.85 532.51 3.34 531.63 3.75 533.08 3.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M520.63,3.47l2.52.14c-.04-.08.28-.13.68-.17-1.55-.02-3.25-.12-3.19.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M523.82,3.44c.81,0,1.58,0,2.03-.08-.44,0-1.38.02-2.03.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "529.63 3.99 528.89 3.89 527.11 3.85 529.63 3.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M493.54,3.37l-2.75.14c-.28.17.47.28,1.49.21.66-.12,1.68-.19,1.26-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M501.86,4.74c-.74-.1-.79-.22-1.21-.38l-.08.62,1.3-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M493.84,4.88c-.27.17-3.99.49-.51.46.28-.17,3.03-.31.51-.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "452.41 4.08 453.11 4.07 453.01 3.06 452.41 4.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M415.89,6.5c3.26.25.77-.63,3.72-.32.77-.24-2.41-.25-1.62-.46-1.97.25-3,.11-2.1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M417.98,5.72c.32-.04.65-.09,1-.15-.57.06-.84.11-1,.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "5.78 1.2 3.68 .99 5.03 1.33 5.78 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M1.75,1.95l-.49-.65L0,1.89c.47-.03,1.39-.08,1.75.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M288.08,7.25l.16-.16c-.32-.17-.81-.18-1.8-.21l1.64.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "OurVisionUnderline-1",
    points: "259.66 6.75 260.15 6.77 259.23 6.18 259.66 6.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "OurVisionUnderline-1",
    d: "M235.81,7.49c.97.02,2.12-.11,3.1-.08-2.12.11-3.36-.65-3.1.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurVisionUnderline);
export default __webpack_public_path__ + "static/media/OurVisionUnderline.4f57eaedab61f0827e68508b344f5bc5.svg";
export { ForwardRef as ReactComponent };